module.exports = __webpack_public_path__ + "img/arrow_back.78d9106e.svg";